<template>
    <van-overlay :show="show" class="loading">
        <div v-show="showView" class="s-overlay">
            <van-loading :color="color" :vertical="vertical" text-size="12px">{{ text }}</van-loading>
        </div>
    </van-overlay>
</template>

<script>
export default {
    name : 'loading',
    props: {
        show    : Boolean,
        showView: {
            type   : Boolean,
            default: true,
        },
        color: {
            type   : String,
            default: 'white',
        },
        // loaing圈与文案是否垂直排列
        vertical: {
            type   : Boolean,
            default: true,
        },
        // 文案
        text: {
            type   : String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>

.loading {
    background-color: rgba(black, 0);
    .s-overlay {
        position: absolute;
        top: calc( 50vh - 12.5vw );
        left: 37.5vw;
        width: 25vw;
        height: 25vw;
        line-height: 25vw;
        background-color: rgba(#101E32, .88);
        border-radius: $radius-s;
        text-align: center;
        .van-loading--vertical {
          height: 100%;
          justify-content: center;
          .van-loading__text {
            line-height: 1.2;
          }
        }
    }
}
</style>
